export default {
  // The banner shown on every page while an SOS is active
  bannerLabel: 'Emergency alerts',
  raised: 'SOS from {name}',
  raisedAt: 'SOS from {name} at {site}',
  accuracy: '±{meters} m',
  viewSite: 'View site',
  openMap: 'Open location',
  // Browser tab title while an alert is active, so it is noticed from another window
  tabTitle: 'SOS ({count}) · {title}',
  // Clearing an alert
  resolve: 'Mark resolved',
  resolveTitle: 'Mark this alert resolved?',
  resolveMessage: 'The SOS from {name} will be cleared for everyone. Only do this once it is being handled.',
  resolvedToast: 'Alert marked resolved.',
  // The Alerts tab on a site
  tabAlerts: 'Alerts',
  tabAlertsActive: 'Alerts ({count})',
  panelTitle: 'Emergency alerts',
  emptyTitle: 'No emergency alerts',
  emptyMessage: 'When someone on site holds the SOS button, the alert shows here and at the top of every page until it is marked resolved.',
  colRaisedBy: 'Raised by',
  colRaised: 'Raised',
  colLocation: 'Location',
  colStatus: 'Status',
  statusActive: 'Active',
  statusResolved: 'Resolved',
  resolvedAt: 'Resolved {when}',
}
